const getters = {
    getDocumentColumnFilter: (state) => {
        let documentSearchHeader = "document_search_header#" + localStorage.getItem('tenantId');
        if(localStorage.getItem(documentSearchHeader) !== null){
            return localStorage.getItem(documentSearchHeader) ? JSON.parse(localStorage.getItem(documentSearchHeader)) : []
        }
        return state.documentSearchHeaders;
    },
};

export default getters;
